import React, {useEffect, useRef, useState} from "react"
import {Card, FormGroup, Switch} from "@blueprintjs/core"
import {useDispatch, useSelector} from "react-redux"
import Props from "../../../core/components/props"
import {
    IMultiSelectItemState,
    MultiSelectString,
} from "../../../core/components/MultiSelectString"
import {
    loadAssayAction,
    loadMaterialsAction,
    loadProjectsAction,
    loadSpeciesAction,
    setDisplayDataContextAction,
    setMultipleContextAction,
} from "../../redux/refdb.actions"
import {
    assaySelector,
    getMultiContext,
    materialsSelector,
    projectsSelector,
    speciesSelector,
} from "../../redux/refdb.selector"
import {RefDbDataContext} from "../../models/displayDataContext"
import handleBooleanChange from "../../../core/utils/handleChangehelpers"
import useComponentWillMount from "../../../core/utils/componentUtils"
import {SingleSelectString} from "../../../core/components/SingleSelectString"

export interface ValueTypeSelectProps extends Props {
    subset: number
}

const BasicsSelectPanel: React.FC<ValueTypeSelectProps> = (props) => {
    const contextData = useSelector(getMultiContext)
    const [context, setContext] = useState<RefDbDataContext>(
        contextData[props.subset]
    )

    const dispatch = useDispatch()

    useComponentWillMount(() => {
        dispatch(loadSpeciesAction(true))
        dispatch(loadMaterialsAction(true))
        dispatch(loadAssayAction(true))
        dispatch(loadProjectsAction(true))
    })

    useEffect(() => {
        console.log("Dispatch context to redux...")
        dispatch(setMultipleContextAction(context))
    }, [context])

    const species = useSelector(speciesSelector)
    const assay = useSelector(assaySelector)
    const materials = useSelector(materialsSelector)
    const projects = useSelector(projectsSelector)

    const updateSwitch = (name: string, value: any) => {
        setContext({
            ...context,
            [name]: {value: context[name].value, enable: value},
        })
    }

    const handleSelect = (e: IMultiSelectItemState) => {
        setContext({
            ...context,
            [e.name]: e.selected,
        })
    }
    const handleSwitchableValue = (e: IMultiSelectItemState) => {
        setContext({
            ...context,
            [e.name]: {value: e.selected, enable: context[e.name].enable},
        })
    }
    const handleSwitchableValueArray = (e: IMultiSelectItemState) => {
        setContext({
            ...context,
            [e.name]: {value: [e.selected], enable: context[e.name].enable},
        })
    }

    return (
        <Card>
            <FormGroup inline label="Species" labelFor="species">
                <SingleSelectString
                    disabled={false}
                    items={species}
                    selected={context.species}
                    handleSelect={handleSelect}
                    name="species"
                />
            </FormGroup>
            <FormGroup inline label="Material" labelFor="material">
                <SingleSelectString
                    disabled={false}
                    selected={context.material}
                    items={materials || []}
                    handleSelect={handleSelect}
                    name="material"
                />
            </FormGroup>
            <FormGroup inline label="Assay" labelFor="assay">
                <SingleSelectString
                    disabled={props.subset !== 0}
                    selected={context.assay.value[0]}
                    items={assay || []}
                    handleSelect={handleSwitchableValueArray}
                    name="assay"
                />
            </FormGroup>
            <div className="CardRow">
                <Switch
                    className="CardRowElement"
                    checked={context.projects.enable}
                    labelElement="Restrict project"
                    onChange={handleBooleanChange((value) =>
                        updateSwitch("projects", value)
                    )}
                />

                <MultiSelectString
                    disabled={!context.projects.enable}
                    selected={context.projects.value}
                    items={projects || []}
                    handleSelect={handleSwitchableValue}
                    name="projects"
                />
            </div>
        </Card>
    )
}

export default BasicsSelectPanel
